import { Component, OnInit, signal, inject, computed, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { CommonModule } from '@angular/common';
import { MATERIAL_MODULES } from '../../Common/material.config';
import { SHARED_DECLARATIONS } from '../../Common/shared.config';
import {
    ReactiveFormsModule, FormsModule,
    FormGroup, FormControl, FormArray,
    Validators,
    AbstractControl,
    AsyncValidatorFn,
    ValidationErrors} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ModalWindowService } from '../../Common/modal-window/modal-window.service';
import { PwdRecoverComponent } from '../pwd-recover/pwd-recover.component';
import { finalize } from 'rxjs';

@Component({
  selector: 'login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ...MATERIAL_MODULES,
    FormsModule,
    MatDatepickerModule, 
    MatTimepickerModule,
    ...SHARED_DECLARATIONS
  ],
  providers: [
    provideNativeDateAdapter()
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  user = signal(''); 
  pwd = signal('');
  hide = signal(true);
  loading = signal(false);
  formInvalid = computed(() => this.user() === '' || this.pwd() === '' || this.loading());

  private _after_login_page = '/home';
  private _LoginS = inject(LoginService);
  private router = inject(Router);
  private _ModalWindowS = inject(ModalWindowService);
  private cdr = inject(ChangeDetectorRef); // Inyecta el detector de cambios

  ngOnInit(): void {
  }

  // -------------------------------------------------------------------------
  public checkUser(): void {
      this.loading.set(true);
      this.cdr.detectChanges();

      this._LoginS.submitLogin(this.user(), this.pwd())
      .pipe(
        // Finalize se ejecuta siempre al terminar (Success o Error)
        finalize(() => {
          this.loading.set(false);
          this.cdr.detectChanges();
        })
      )
      .subscribe({
          next: (response:boolean) => {
              if ( response === false ) {
                  this._loginFail('Invalid user/password');
              } else {
                  this._loginOK(response)
              }
          },
          error: (error:any) => {
            this._loginFail(typeof error === 'string' ? error : error.message);
            console.log('LoginComponent', error);
            this.cdr.detectChanges();
          },
          complete: () => {
            this.loading.set(false);
            this.cdr.detectChanges();
          }
      });
  }

  // -------------------------------------------------------------------------
  public registrarse(): void {
   
    this.router.navigate(['/registro']);
  
  }

  // -------------------------------------------------------------------------
  public openPasswordRecoveryWindow(): void {
      const on_close_window = this._ModalWindowS.showComponent(
          PwdRecoverComponent,
          {msg: 'error', type:'info', title:'Mail recovery'});

      on_close_window.subscribe( (result: any) => {
        if (result) {
          this._showMailSendedOK();
        }
      });
  }

  // =========================================================================
  // Private methods
  // -------------------------------------------------------------------------
  private _showMailSendedOK() {
      this._ModalWindowS.showMessageInfo('Mail sended ok', 'Recovery password');
  }

  private _loginOK(response:any) {
      console.log(response);
      this._LoginS.onLoginOK(response);
      this.router.navigate([this._after_login_page]);
  }

  private _loginFail(error:any) {
      try {
        this._ModalWindowS.showMessageError(error);
      } catch (exception) {
        console.log(exception);
      }
  }
}
